/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGcpIamPlatformCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGcpIamPlatformCredentialRequest = {
  /**
   * The ID of the credential to get.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGcpIamPlatformCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpIamPlatformCredentialSecurity$outboundSchema: z.ZodMiniType<
  GetGcpIamPlatformCredentialSecurity$Outbound,
  GetGcpIamPlatformCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getGcpIamPlatformCredentialSecurityToJSON(
  getGcpIamPlatformCredentialSecurity: GetGcpIamPlatformCredentialSecurity,
): string {
  return JSON.stringify(
    GetGcpIamPlatformCredentialSecurity$outboundSchema.parse(
      getGcpIamPlatformCredentialSecurity,
    ),
  );
}

/** @internal */
export type GetGcpIamPlatformCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpIamPlatformCredentialRequest$outboundSchema: z.ZodMiniType<
  GetGcpIamPlatformCredentialRequest$Outbound,
  GetGcpIamPlatformCredentialRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getGcpIamPlatformCredentialRequestToJSON(
  getGcpIamPlatformCredentialRequest: GetGcpIamPlatformCredentialRequest,
): string {
  return JSON.stringify(
    GetGcpIamPlatformCredentialRequest$outboundSchema.parse(
      getGcpIamPlatformCredentialRequest,
    ),
  );
}
